import { Table, Form, Col, Row, Modal, Alert, Button, Select } from 'antd';
import axios from '../../utils/request';
import React, { Component } from 'react';
import { Spinner } from 'reactstrap';
import UmRichEditor from "@beisen-phoenix/richeditor";

const { Option } = Select;

const columns = [
    {
        title: '校验信息',
        dataIndex: 'message',
        width: 800,
    }
];

const toolbar = [
    //"source | undo redo | fontfamily | fontsize | forecolor | bold italic underline strikethrough |",
    //" cleardoc removeformat | insertorderedlist insertunorderedlist",
    //"| justifyleft justifycenter justifyright justifyjustify indent outdent |",
    //"link unlink | image video music",
    //"| horizontal preview inserttable"
];

export class SanQiHuYuSendWrittenExam extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            errorMessage: null,
            applicantList: null,
            templateList:[],
            //templateList:
            //    [
            //        { id: "BackgroundInvestigationStatusChange", title: "背调切换状态", emailContent: "<p><span><span><span class=\"__template_keyword\">${Model:bc:Recruitment.ThirdBackgroundInvestigationTask:ArrangedBy}</span></span></span>您好！您通过<span><span><span class=\"__template_keyword\">${Model:bc:Recruitment.ThirdBackgroundInvestigationTask:ThirdAppCode}</span></span></span>委托的<span><span><span class=\"__template_keyword\">${Model:bc:Recruitment.ThirdBackgroundInvestigationTask:ApplicantName}</span></span></span>的背调状态为<span><span><span class=\"__template_keyword\">${Model:bc:Recruitment.ThirdBackgroundInvestigationTask:Status}</span></span></span><span>。</span></p>" },
            //        { id: "BackgroundInvestigationReportCreateOrUpdate", title: "背调部分报告更新及生成给HR发通知", emailContent: "<span><span><span class=\"__template_keyword\">${Model:bc:Recruitment.ThirdBackgroundInvestigationTask:ArrangedBy}</span></span></span>您好！您通过<span><span><span class=\"__template_keyword\">${Model:bc:Recruitment.ThirdBackgroundInvestigationTask:ThirdAppCode}</span></span></span>委托的<span><span><span class=\"__template_keyword\">${Model:bc:Recruitment.ThirdBackgroundInvestigationTask:ApplicantName}</span></span></span>的部分背调报告已生成或更新。" },
            //        { id: "SendBackgroundInvestigationExceptionNoticeToHR", title: "背调异常内容给HR发通知", emailContent: "<p><span style=\"color: rgba(0, 0, 0, 0.65); font-family: sans-serif; white-space: normal;\"><span><span><span class=\"__template_keyword\">${Model:bc:Recruitment.ThirdBackgroundInvestigationTask:ArrangedBy}</span></span></span></span><span style=\"color: rgba(0, 0, 0, 0.65); font-family: sans-serif; white-space: normal;\">您好！您通过</span><span style=\"color: rgba(0, 0, 0, 0.65); font-family: sans-serif; white-space: normal;\"><span><span><span class=\"__template_keyword\">${Model:bc:Recruitment.ThirdBackgroundInvestigationTask:ThirdAppCode}</span></span></span> </span><span style=\"color: rgba(0, 0, 0, 0.65); font-family: sans-serif; white-space: normal;\">委托的 </span><span style=\"color: rgba(0, 0, 0, 0.65); font-family: sans-serif; white-space: normal;\"><span><span><span class=\"__template_keyword\">${Model:bc:Recruitment.ThirdBackgroundInvestigationTask:ApplicantName}</span></span></span></span><span style=\"color: rgba(0, 0, 0, 0.65); font-family: sans-serif; white-space: normal;\">的背调出现</span><span style=\"color: rgba(0, 0, 0, 0.65); font-family: sans-serif; white-space: normal;\"><span><span><span class=\"__template_keyword\">${Model.ExceptionTypeName}</span></span></span> </span><span style=\"color: rgba(0, 0, 0, 0.65); font-family: sans-serif; white-space: normal;\">的情况，原因是</span><span style=\"color: rgba(0, 0, 0, 0.65); font-family: sans-serif; white-space: normal;\"><span><span><span class=\"__template_keyword\">${Model.ExceptionDescription}</span></span></span></span></p>" }
            //    ],
            templateCode: null,
            templateContent:"",
            buttonStatus: false,
            visible: false,
            submitSuccess: true,
            commonParamater: null,
            displayStatus: 'none',
            tenantId: null
        };
    }

   

    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        const commonParamater = urlParams.get("commonParamater");
        const tenantId = urlParams.get("tenantId");
        this.setState({ commonParamater: commonParamater, tenantId: tenantId });
        const params = {
            tenantId,
            commonParamater
        }
        axios
            .get("/api/SanQiHuYu/VerifyApplicantInfo", { params: params })
            .then(res => {
                const data = res.data.data;
                console.log(data);
                this.setState({ applicantList: data.applicants, templateList: data.templateList, isLoading: true, buttonStatus: false });
                
            }).catch(reason => {
                const errorMessages = reason?.response?.data?.errorMessages ?? ["获取初始信息失败。"]
                this.setState({ errorMessage: errorMessages });
                this.setState({ isLoading: true });
            })
    }

    render() {
        if (this.state.isLoading) {
            if (this.state.errorMessage != null) {
                return (<div style={{ textAlign: "center", padding: "32px" }}><span style={{ color: "red" }}>{this.state.errorMessage}</span></div>)
            }
            else {
                return (
                    <div style={{ margin: "32px auto", maxWidth: "1000px" }}>
                        <Form onFinish={this.showModal}>                      
                            <Row>
                                <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                                    <Form.Item label="选择邮件模板" name="templateCode"
                                        rules={[
                                            {
                                                required: true,
                                                message: "类型不能为空！"
                                            }
                                        ]}>
                                        <Select
                                            showSearch
                                            optionFilterProp="children"
                                            filterOption={(input, option) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                            onChange={ this.selectChange}
                                            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                            style={{ width: '50%' }}
                                            placeholder="请选择邮件模板">
                                            {this.state.templateList.map(el => (
                                                <Option value={el.id} key={el.id} >{el.title}</Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}  >
                                    <Table columns={columns} dataSource={this.state.applicantList} pagination={false} size="small" />
                                </Col>
                            </Row>

                            <Row>
                                <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}  >
                                    <label>邮件正文</label>
                                    <UmRichEditor
                                        id="rich-basic-usage"
                                        toolbar={toolbar}
                                        autoHeightEnabled={true} // 高度自适应,默认为true
                                        //height="500" // 自定义高度为500
                                        editStatus={false} // 默认为true,可以显式设置为false来禁用编辑功能
                                        draggable={true}
                                        errorStatus={this.state.errorStatus}
                                        errorMsg='该字段为必填字段,请认真填写'
                                        onChange={this.handleChange}
                                        onFocus={this.handleFocus}
                                        defaultValue={this.state.templateContent}
                                        value={this.state.templateContent }
                                    />
                                </Col>
                            </Row>

                            <div>
                                <Modal title="发送笔试" visible={this.state.visible} onOk={this.handleOk} onCancel={this.handleCancel} cancelText="取消" okText="发送">
                                    <p>确定发送笔试？</p>
                                </Modal>
                            </div>
                            <Row>
                                <Col xs={{ span: 24 }} md={{ span: 5 }} lg={{ span: 5, offset: 10 }}>
                                    <br />
                                    <Button type="primary" disabled={this.state.buttonStatus} htmlType="submit" onClick={this.showModal}>继续</Button>
                                </Col>
                            </Row>
                        </Form>
                        <div style={{ display: this.state.displayStatus }}>
                            <Alert message="发送成功" type="success" showIcon closable={true} />
                        </div>
                    </div>)
            }
        } else {
            return (
                <div style={{ textAlign: "center", lineHeight: "100vh" }}>
                    <Spinner type="grow" color="primary" />
                    <Spinner type="grow" color="secondary" />
                    <Spinner type="grow" color="success" />
                    <Spinner type="grow" color="danger" />
                    <Spinner type="grow" color="warning" />
                    <Spinner type="grow" color="info" />
                    <Spinner type="grow" color="dark" />
                </div>
            );
        }
    }

    onFormSubmit = () => {
        this.setState({ isLoading: true });
        setTimeout(() => {
            this.setState({ isLoading: false, submitSuccess: true });
        }, 2000)
    }
    selectChange = value => {
        console.log(value)
        var content = this.state.templateList.find(e => { return e.id === value }).emailContent;
        this.setState({ templateCode: value, templateContent: content, visible: false });

    }

    showModal = values => {    
        this.setState({ templateCode: values.templateCode,  visible: true });
    }

    handleOk = values => {
        const commonParamater = this.state.commonParamater;
        const tenantId = this.state.tenantId;
        const templateCode = this.state.templateCode;
        window.location.href = "/sanqihuyu_send_success?commonParamater=" + commonParamater + "&tenantId=" + tenantId + "&templateCode=" + templateCode;
    }

    handleCancel = (e) => {
        this.setState({ visible: false });
    }

}